<button [disabled]="disabled()" [ngClass]="classNames()">
  <ng-content></ng-content>
</button>
